import * as React from 'react';
import { FormProvider, Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LocalizationForm from '../LocalizationForm/LocalizationForm';
import { useModals } from 'hooks/useModals';
import { useAppDispatch } from 'store/store';

import { TLocalizationFormValues } from '../LocalizationForm/LocalizationForm.types';
import { TLocalizationAdd } from './LocalizationAdd.types';
import { STATIC_LOCALIZATION_FORM_DEFAULT_VALUES } from '../LocalizationForm/constants';
import { getLocalizationFormSchema } from '../LocalizationForm/LocalizationForm.schema';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

const LocalizationAdd: TLocalizationAdd = () => {
  const localize = useLocalize();
  const dispatch = useAppDispatch();
  const modals = useModals();

  const localizationFormSchema = React.useMemo(
    () => getLocalizationFormSchema(localize),
    [localize]
  );

  const form = useForm<TLocalizationFormValues>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: STATIC_LOCALIZATION_FORM_DEFAULT_VALUES,
    resolver: yupResolver(
      localizationFormSchema
    ) as Resolver<TLocalizationFormValues>,
  });

  const handleSubmit = (data: TLocalizationFormValues) => {
    // dispatch(
    //   createLocalizationAsyncThunk({
    //     body: data,
    //     onSuccess: () => {
    //       modals.closeModal();
    //       dispatch(getLocalizationListAsyncThunk());
    //     },
    //   })
    // );
  };

  return (
    <FormProvider {...form}>
      <LocalizationForm onSubmit={handleSubmit} />
    </FormProvider>
  );
};

export default LocalizationAdd;
